import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { GetServerSideProps } from 'next';

interface IPrivacyPolicyProps {
  content: string | null;
  frontmatter: { title: string };
}

const PrivacyPolicy: NextPageWithLayout<IPrivacyPolicyProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

PrivacyPolicy.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_privacypolicy"
    titleStaging="Privacy policy"
    metaDescriptionProd="meta_description_production_privacypolicy"
    metaDescriptionStaging="Allmyles API privacy policy lets you understand how we handle your data"
    canonicalProd="https://tipptour.com/privacy-policy"
    canonicalStaging="https://showcase.allmyles.com/privacy-policy">
    {page}
  </Layout>
);
export default PrivacyPolicy;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(
        process.cwd(),
        `assets/localization/privacy_policy/${env}/${locale}.md`,
      ),
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
      } as IPrivacyPolicyProps,
    };
  } catch (err) {
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: { title: '' },
        content: null,
      } as IPrivacyPolicyProps,
    };
  }
};
